import React, { useState, useEffect, Fragment } from 'react'
import { useShared } from '../../hooks/useShared'
import AMenu from '../../components/partials/AMenu';
import MainSection from '../../components/sections/MainSection';


const TABLE_HEAD = ["No.", "نام", "نام انگلسی", "نوع", 'ايجاد کننده', 'تاريخ ايجاد', 'اقدامات'];
const breadcrumbs = [{ name: 'کتگری‌ها', link: '/categories' }]
const menuData = [
   {flag:"Edit",  name: 'ويرايش', icon: 'create-outline', roles: [1, 2,25] },
  { flag:"Delete", name: 'حذف', icon: 'trash-outline', roles: [1] },
]


const searchInputFields = [
  { label: 'نام', name: 'sName', type: 'text', roles: [1], icon: 'text-outline', className: 'md:col-span-2' },
  { label: 'نوع', name: 'parent', type: 'select', roles: [1], icon: 'text-outline', className: 'md:col-span-2', options: [] },
  { label: 'ايجاد کننده', name: 'creator_id', type: 'select', roles: [1], icon: 'text-outline', className: 'md:col-span-2', },

];


const newModelInputFields = [

  { label: 'نام', name: 'name_af', type: 'text', roles: [1], icon: 'text-outline', className: '', required: 'The local name is requieed', isStyle: false },
  { label: 'نام انکلسی', name: 'name', type: 'text', roles: [1], icon: 'text-outline', className: '', required: 'The name is requieed', isStyle: false },
  {
    label: 'نوع', name: 'parent', type: 'select', roles: [1], icon: 'text-outline', className: '', required: false,
    options: []
  },

  { label: 'حالت', name: 'status', type: 'switch', roles: [1], icon: 'book-outline', className: '', required: false, status: true },

  { label: 'ملاحظات', name: 'description', type: 'textarea', roles: [1], icon: 'book-outline', className: '', required: false, isStyle: false },

];


export default function Category() {

  const [loading, setLoading] = useState({ submit: false, all: 0 })

  const { http, com, setModel,
    models,  setShowNewModelDialog, setShowViewDialog,navigate,auth,
    showDeleteDialog, setShowDeleteDialog } = useShared();

    useEffect(() => {
      if (!auth.hasRole([1,2,25,3])) {
          return navigate("/db/notAllowed")
      }
    }, [])
  const [inputFields, setInputFields] = useState([...newModelInputFields])


  const getParentCategories = () => {
    setLoading(pre => ({ ...pre, show: true }))
    const res = http.post('api/categoryAdvanceSearch', { nameId: true }).then(res => {
      console.log("categories ", res);
      if (res.data.success) {
        setLoading(pre => ({ ...pre, show: false }))
        newModelInputFields[2].options = res.data?.data
        setInputFields(newModelInputFields)
      }
    }, err => {
      setLoading(pre => ({ ...pre, show: false }))
      console.log('getParentCategories error ', err);
    })
  }

  const handleMenu = (model, flag = false) => {
    console.log("handleMenu ", model, flag);

    if (flag === 'delete') {
      setModel(model)
      setShowDeleteDialog(!showDeleteDialog)
    }
    if (flag === 'edit') {
      setModel(model)
      getParentCategories()
      setShowNewModelDialog(true)
    }
    if (flag === 'view') {
      setModel(model)
      setShowViewDialog(true)
    }
  };



  const handleViewDialog = (obj) => {
    return [
      { l: 'Name', v: obj?.name },
      { l: 'Type', v: obj?.parent?.label },
      { l: 'Description', v: obj?.description },
      { l: 'Added by', v: obj?.user?.full_name },
      { l: 'Status', v: obj?.status },
      { l: 'Last Update', v: com.ddmmyyhhmmA(obj?.updated_at) },
    ]
  }

  const getTableData = () => {

    return (<tbody className=''>
      {models?.data?.map((r, i) => {
        return (
          <Fragment key={i}>
            {setTableData(r, i, 0)}
            {r.parent === null && r?.children?.map((c, j) => setTableData(c, i, j))}
          </Fragment>)
      })}
    </tbody>)
  }

  const setTableData = (r, i, j) => {

    return (
      <tr key={r.id} className={`${r.parent === null ? '!bg-green-600/10 !font-bold ' : ''}`}>
        <td >{models?.from + i}{r.parent && <span>.{j + 1}</span>} </td>

        <td className='!p-1 !text-right'>
          <div className='flex  items-center w-full'>
            <div className={` rounded-full h-3 w-3 mx-2 ${r.status === 1 || r.status ? 'bg-green-500' : 'bg-red-700'}`} />
            <span className='text-base'>{r.name_af} </span>
          </div>
        </td>
        <td className='w-[30%]'>{r?.name}</td>
        <td className='capitalize'>{r?.parent?.label ? r?.parent?.label : '-- Category --'}</td>
        <td >{r?.user?.full_name}</td>

        <td  style={{direction:'ltr'}}>{com.dateConvert(r?.created_at, false, true)}</td>
        <td >
          <AMenu v={{ handleMenu: (row, flag) => handleMenu(row, flag), row: r, menuData }} />

        </td></tr>)
  }



  return (
      <MainSection v={{
        handleViewDialog,
        newModelInputFields: inputFields,
        searchInputFields,
        TABLE_HEAD,
        breadcrumbs,
        tableData: getTableData(),
        url: "categories",
        modelName: { name: 'categories', af: 'کتیگری' },
        mUrl: { delete: 'categories', create: 'categories', getAll: 'categoryAdvanceSearch' },
        addNewItemTitle: "کتگری جديد",
        tableTitle: 'لست کتگری',
        advanceSearch: 'categoryAdvanceSearch',
        modelScreen: 'Categories',
      }} />
  )

}
